module.exports = __webpack_public_path__ + "img/nt56-03-80-1-asm.prt.bda25d93.jpg";